import { createFileRoute } from '@tanstack/react-router'

import { EvaluationAnswerPage } from '@/features/evaluations'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute(
  '/_authenticated/_main/avaliacoes/$evaluationId'
)({
  head: () => ({
    meta: [{ title: buildPageTitle('Avaliação') }]
  }),
  component: EvaluationAnswerRoute
})

function EvaluationAnswerRoute() {
  const { evaluationId } = Route.useParams()

  return <EvaluationAnswerPage evaluationId={evaluationId} />
}
